import {UPDATE_PROFILE} from "../types/types";

export  default function UserProfileReducer (state  = {},  action) {
    let res;
    switch (action.type) {
        case UPDATE_PROFILE:
            res =  Object.assign({}, state, action.payload);
            return res;
        default:
            return state;
    }
}
